import { get, post } from "services/services.methods";
import { QuotesOrdersPaths, QuotesReportPaths, Reports } from 'services/services.paths';
import { GenericApiResponse, QuotesR, QuotesReport } from "interfaces";

export const createQuotesRegistration = async (QuotesOrder: QuotesR) => {
  const response = await post<any>(QuotesOrdersPaths.post, QuotesOrder);

  return response;
};

export const getCashRegisterClosingReport = async (startDate: string, endDate: string, idEmployee:number, idBranch: number) => {
  const response = await get<any[]>(
    `${Reports.getCashRegisterReport}/${startDate}/${endDate}?sucursal=${idBranch}&usuario=${idEmployee}`
  );

  return response;
};



export const getlistQuotes = async (
  purchaseParams: { customerId : number; dateFrom: string; dateTo: string; branchId: number, quotationId :number }
): Promise<GenericApiResponse<QuotesReport[]>> => {
  
  const url = `${QuotesReportPaths.post}?customerId =${purchaseParams.customerId }&dateFrom=${purchaseParams.dateFrom}&dateTo=${purchaseParams.dateTo}&branchId=${purchaseParams.branchId}&quotationId =${purchaseParams.quotationId }`;
  const response = await post<QuotesReport[]>(QuotesReportPaths.post, purchaseParams);


  return response;
};
